const initializedPoeticProducts = new WeakSet();
const initializePoeticProducts = (root = document) => root.querySelectorAll('[data-ps-product]').forEach((panel) => {
  if (initializedPoeticProducts.has(panel)) return;
  initializedPoeticProducts.add(panel);
  const select = panel.querySelector('[data-size-select]');
  const price = panel.querySelector('[data-price]');
  const button = panel.querySelector('[data-add-button]');
  const media = panel.querySelector('.ps-product-media');
  const optionFields = panel.querySelector('[data-option-fields]');
  const optionPickers = Array.from(panel.querySelectorAll('[data-print-option]'));
  const variantFallback = panel.querySelector('[data-variant-fallback]');
  const variants = optionPickers.length ? Array.from(select.options).map((option) => ({
    option,
    values: JSON.parse(option.dataset.options || '[]')
  })) : [];
  if (optionPickers.length) {
    const initial = variants.find((variant) => variant.option.selected);
    optionPickers.forEach((picker) => {
      if (initial) picker.value = initial.values[Number(picker.dataset.optionIndex)];
    });
    optionFields.hidden = false;
    variantFallback.hidden = true;
  }
  const update = () => {
    const option = select?.selectedOptions[0];
    if (!option) return;
    if (price && option.dataset.price) {
      const currency = price.querySelector('span')?.cloneNode(true);
      price.textContent = option.dataset.price;
      if (currency) price.append(currency);
    }
    if (media) media.dataset.format = option.dataset.format || '16x20';
    const paper = option.dataset.paper?.includes('Museum Grade') ? 'museum' : 'fine';
    panel.querySelectorAll('[data-paper-note]').forEach((note) => {
      note.hidden = note.dataset.paperNote !== paper;
    });
    const resolutionNote = panel.querySelector('[data-resolution-note]');
    if (resolutionNote) resolutionNote.hidden = option.dataset.format !== '18x24';
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
    }
  };
  optionPickers.forEach((picker) => picker.addEventListener('change', () => {
    const variant = variants.find((candidate) => optionPickers.every((field) =>
      candidate.values[Number(field.dataset.optionIndex)] === field.value
    ));
    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.unavailableLabel;
      }
      return;
    }
    select.value = variant.option.value;
    update();
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url);
  }));
  select?.addEventListener('change', update);
  update();
});
const initializedPoeticRooms = new WeakSet();
const initializePoeticRooms = (root = document) => root.querySelectorAll('[data-ps-rooms]').forEach((gallery) => {
  if (initializedPoeticRooms.has(gallery)) return;
  initializedPoeticRooms.add(gallery);
  const controls = gallery.querySelector('[data-room-controls]');
  const choices = Array.from(gallery.querySelectorAll('[data-room-choice]'));
  const panels = Array.from(gallery.querySelectorAll('[data-room-panel]'));
  const showRoom = (key) => {
    choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice.dataset.roomChoice === key)));
    panels.forEach((panel) => { panel.hidden = panel.dataset.roomPanel !== key; });
  };
  choices.forEach((choice) => choice.addEventListener('click', () => showRoom(choice.dataset.roomChoice)));
  showRoom('living');
  controls.hidden = false;
});
initializePoeticProducts();
initializePoeticRooms();
document.addEventListener('shopify:section:load', (event) => {
  initializePoeticProducts(event.target);
  initializePoeticRooms(event.target);
});
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const opener = event.target.closest('[data-open-art]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const closer = event.target.closest('[data-close-art]');
  if (closer) closer.closest('dialog')?.close();
  else if (event.target.matches('[data-art-dialog]')) event.target.close();
});

